module.exports = __webpack_public_path__ + "img/bg_sev_a.c09dab45.jpg";